import type { QueryClient } from "@tanstack/react-query";
import { queryOptions } from "@tanstack/react-query";
import { redirect } from "@tanstack/react-router";
import { api, unwrap } from "@/shared/lib/apiClient";
import { ApiError } from "@/shared/utils/apiError";

export const authKeys = {
  me: ["auth", "me"] as const,
};

export const meQueryOptions = queryOptions({
  queryKey: authKeys.me,
  queryFn: async () => unwrap(await api.GET("/api/auth/me")),
});

// Route-guard step: return `me`, or redirect to /login on 401 (other errors hit the error boundary).
// Callers throw their role-based redirect AFTER this, outside any try, so it isn't swallowed here.
export async function loadMeOrLogin(queryClient: QueryClient) {
  try {
    // fetchQuery (not ensureQueryData) re-verifies once `me` goes stale (30s), so a revocation redirects within 30s.
    return await queryClient.fetchQuery(meQueryOptions);
  } catch (err) {
    if (err instanceof ApiError && err.status === 401) {
      throw redirect({ to: "/login" });
    }
    throw err;
  }
}
